import { render, staticRenderFns } from "./RedirectPayStripe.vue?vue&type=template&id=6f74c85d&"
import script from "./RedirectPayStripe.vue?vue&type=script&lang=js&"
export * from "./RedirectPayStripe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports